<template>
  <div class="activities">
    <div class="title">
      <div></div>
      轮播图管理
    </div>
    <div class="query">
      <div class="query-box">
        <el-input v-model="query" placeholder="轮播图名称"></el-input>
      </div>
      <div class="query-box">
        <el-select v-model="type" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <el-button type="primary" @click="inquire">查询</el-button>

      <el-button type="primary" @click="addBanner">添加banner</el-button>
    </div>
    <div class="activities-main">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" type="index" label="序号" width="50">
        </el-table-column>

        <el-table-column align="center" prop="name" label="banner名称">
        </el-table-column>

        <el-table-column align="center" prop="url" label="banner图片">
          <template slot-scope="images">
            <el-image
              style="width: 50px; height: 50px"
              class="table-td-thumb"
              :src="images.row.url"
              :preview-src-list="[images.row.url]"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="barName" label="酒吧名称">
        </el-table-column>

        <el-table-column align="center" prop="startTime" label="开始时间">
        </el-table-column>

        <el-table-column align="center" prop="endTime" label="结束时间">
        </el-table-column>

        <el-table-column
          align="center"
          prop="sort"
          label="排序（规则：数字升序）"
        >
          <template slot-scope="scope">
            <div>
              <el-input
                type="number"
                @blur="setSorts(scope.row.id, scope.row.sort)"
                v-model="scope.row.sort"
                placeholder="轮播图名称"
              ></el-input>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="" label="状态">
          <template slot-scope="scope">
            <div :class="scope.row.isOff == true ? '' : 'active'">
              {{ scope.row.isOff == true ? "已下架" : "已上架" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="240">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="bannerDetail(scope.row.id)"
              >编辑</el-button
            >

            <el-button
              v-if="scope.row.isOff == 1"
              size="mini"
              type="success"
              @click="isOff(scope.row.id, 0)"
              >上架</el-button
            >

            <el-button
              v-else
              size="mini"
              type="info"
              @click="isOff(scope.row.id, 1)"
              >下架</el-button
            >

            <el-button
              size="mini"
              type="danger"
              @click="delBanner(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import local from "@/utils/local.js";
import { bannerPage, delBanner, onOff,setSort} from "@/api/api";
export default {
  data() {
    return {
      //  activityId: "",
      ruleList: [],
      query: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      adminId: "",
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "已上架",
        },
        {
          value: "1",
          label: "已下架",
        },
      ],
      type: "",
    };
  },
  created() {
    this.adminId = local.get("id");
    this.getList();
  },
  methods: {
    bannerDetail(id) {
      this.$router.push("bannerDetail?bannerId=" + id);
    },

    addBanner(id) {
      this.$router.push("addBanner?bannerId=" + id);
    },

    async setSorts(id, num) {
      let res = await setSort({
        id:id,
        num:num,
      });
      if (res.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            this.getList();
          }
    },

    delBanner(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await delBanner({
            id: id,
          });
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //  获取banner列表
    async getList() {
      let isOff = "";
      if (this.type) {
        isOff = this.type == 1 ? true : false;
      } else {
        isOff = "";
      }

      let res = await bannerPage({
        query: this.query,
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        isOff: isOff,
      });
      console.log(res);
      let { data } = res;
      //边界判断
      if (!data.itemList.length && this.currentPage !== 1) {
        this.currentPage -= 1;
        this.getList();
      }
      this.tableData = data.itemList;
      console.log(this.tableData, 9898);
      this.total = data.totalSize;
    },
    // 查询
    inquire() {
      this.getList();
    },
    // 刷新
    refresh() {
      this.query = "";
      this.getList();
    },
    // 轮播上下架
    isOff(id, isOff) {
      this.$confirm(isOff == 0 ? "是否确定上架" : "是否确定下架", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await onOff({
            id: id,
            isOff: isOff,
          });
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "编辑成功!",
            });
            this.getList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消编辑",
          });
        });
    },
    //每页多少条
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    //当前多少页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.activities {
  // height: 100%;
  background: #fff;
  padding: 15px;
  color: #303133;
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    div {
      width: 3px;
      height: 16px;
      background: #409eff;
      margin-right: 10px;
    }
  }
  .query {
    margin: 15px 0 30px;
    display: flex;
    align-items: center;
    .query-box {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .el-input {
        width: 260px;
      }
      span {
        width: 60px;
      }
    }
  }
  .activities-main {
    margin: 15px 0;
  }
  .paging {
    display: flex;
    justify-content: flex-end;
  }
}
.active {
  color: #33b959;
}
</style>